import { Hill } from './../../shared/model/hill.model';
import { BaseState } from './../../shared/base/base.state';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { StorageService } from './../../shared/services/storage.service';
import { Component, OnInit, ViewChild } from '@angular/core';
const screenfull = require('screenfull');
const browser = require('jquery.browser');
declare var $: any;

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { BaseStateActions } from '../../shared/base/base.actions';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout

    isNavSearchVisible: boolean;

    public selectedHill: Hill = this.store.selectSnapshot(BaseState.getSelectedHill);
    public userHills: Hill[] = [];

    @ViewChild('fsbutton') fsbutton; // the fullscreen button

    constructor(
        public menu: MenuService,
        public userblockService: UserblockService,
        public settings: SettingsService,
        private storage: StorageService,
        private router: Router,
        private store: Store,
    ) {
        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
    }

    ngOnInit() {
        this.isNavSearchVisible = false;
        if (browser.msie) {
            // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
        this.userHills = this.store.selectSnapshot(BaseState.getUserHills);
        if (this.userHills && this.selectedHill) {
            this.userHills.filter((el) => el?.id != this.selectedHill?.id);
        }
    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.layout.offsidebarOpen = !this.settings.layout.offsidebarOpen;
    }

    toggleCollapsedSideabar() {
        this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
    }

    isCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        let el = $(this.fsbutton.nativeElement);
        if (screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        } else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }
    signOut(): void {
        this.storage.clearUserData();
        this.store.dispatch(BaseStateActions.ClearBaseState);
        this.router.navigate(['/login']);
    }

    public switchToHill(hill: Hill): void {
        this.store.dispatch(new BaseStateActions.Common.SetSelectedHill(hill)).subscribe(() => {
            this.selectedHill = hill;
            let currentUrl = this.router.url;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
            });
        });
    }
}
